import { PayloadAction } from '@reduxjs/toolkit';
import { ISidebar } from '../../core/components/sidebars/ISidebar';

export const SidebarReducer = {
	toggleSidebar: (state: ISidebar, action: PayloadAction<ISidebar>) => {
		state.isOpen = action.payload.isOpen;
		state.component = action.payload.component;
		state.componentProps = action.payload.componentProps;
		state.title = action.payload.title;
	},
};
